export default {
    get_device_info({ commit }) {
        commit('m_device_info');
      },
}


// WEBPACK FOOTER //
// ./src/store/actions.js